// extracted by mini-css-extract-plugin
export default {"headerDiv":"Messages_headerDiv__rNt29","mainContainer":"Messages_mainContainer__NlL17"};